import { types } from 'mobx-state-tree';

const PaymentModule = types.model('PaymentModule', {
  logo: types.maybeNull(types.string),
  name: types.maybeNull(types.string)
});

export default PaymentModule;



// WEBPACK FOOTER //
// ./src/models/PaymentModule.js